import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

export const WithdrawsMain = () => {

	const withdrawals = useSelector((state: IState) => state.withdrawals)

	React.useEffect(
		() => {
			ws.send({ type: 'Withdrawals.Get' } as any)
		},
		[])

	return (
		<div className='withdrawMain'>
			<span className='pageTitle'>Withdrawals</span>
			<span className='pageBoxTitle'>Pending Fiat Withdrawals</span>
			<div>
				<table className='withdrawsTableMain'>
					<thead>
						<tr className='withdrawsTableHeaderRow'>
							<td className='withdrawsTableHeaderRowItem'>Withdraw ID</td>
							<td className='withdrawsTableHeaderRowItem'>Date</td>
							<td className='withdrawsTableHeaderRowItem'>Coin</td>
							<td className='withdrawsTableHeaderRowItem'>Amount</td>
							<td className='withdrawsTableHeaderRowItem'>Bank Account</td>
							<td className='withdrawsTableHeaderRowItem'>Full Name</td>
							<td className='withdrawsTableHeaderRowItem'>Document ID Number</td>
							<td className='withdrawsTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						{withdrawals.map(m =>
							<tr className='withdrawsTableBodyRow' key={m.id}>
								<td className='withdrawsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.id), 6)}</td>
								<td className='withdrawsTableBodyRowItem'>{m.date ? new Date(m.date).toLocaleString('en-GB') : ''}</td>
								<td className='withdrawsTableBodyRowItem'>{m.coin}</td>
								<td className='withdrawsTableBodyRowItem'>{(m.amount - m.fee).toFixed(2)}</td>
								<td className='withdrawsTableBodyRowItem'>{m.bankAccount}</td>
								<td className='withdrawsTableBodyRowItem'>{m.fullName}</td>
								<td className='withdrawsTableBodyRowItem'>{m.docIdNumber}</td>
								<td className='withdrawsTableBodyRowItem'><Link className='walletsTableButton' to={`/withdrawDetailsFiat/${m.id}`}>View Details</Link></td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{/* <br /><br />
			<span className='pageBoxTitle'>Pending Crypto Withdrawals</span>
			<div>
				<table className='withdrawsTableMain'>
					<thead>
						<tr className='withdrawsTableHeaderRow'>
							<td className='withdrawsTableHeaderRowItem'>Withdraw ID</td>
							<td className='withdrawsTableHeaderRowItem'>Date</td>
							<td className='withdrawsTableHeaderRowItem'>Coin</td>
							<td className='withdrawsTableHeaderRowItem'>Amount</td>
							<td className='withdrawsTableHeaderRowItem'>Address</td>
							<td className='withdrawsTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						<tr className='withdrawsTableBodyRow'>
							<td className='withdrawsTableBodyRowItem'>014AHZ</td>
							<td className='withdrawsTableBodyRowItem'>8/10/2018, 09:11:33 AM</td>
							<td className='withdrawsTableBodyRowItem'>BTC</td>
							<td className='withdrawsTableBodyRowItem'>3.00000000</td>
							<td className='withdrawsTableBodyRowItem'>mqq8sZHJkT9KyLyhDf6jSZtWuqeR9aCRTc</td>
							<td className='ordersTableBodyRowItem'><Link className='walletsTableButton' to='/withdrawDetailsCrypto'>View Details</Link></td>
						</tr>
						<tr className='withdrawsTableBodyRow'>
							<td className='withdrawsTableBodyRowItem'>014AHZ</td>
							<td className='withdrawsTableBodyRowItem'>8/10/2018, 09:11:33 AM</td>
							<td className='withdrawsTableBodyRowItem'>BTC</td>
							<td className='withdrawsTableBodyRowItem'>3.00000000</td>
							<td className='withdrawsTableBodyRowItem'>mqq8sZHJkT9KyLyhDf6jSZtWuqeR9aCRTc</td>
							<td className='ordersTableBodyRowItem'><Link className='walletsTableButton' to='/withdrawDetailsCrypto'>View Details</Link></td>
						</tr>
						<tr className='withdrawsTableBodyRow'>
							<td className='withdrawsTableBodyRowItem'>014AHZ</td>
							<td className='withdrawsTableBodyRowItem'>8/10/2018, 09:11:33 AM</td>
							<td className='withdrawsTableBodyRowItem'>BTC</td>
							<td className='withdrawsTableBodyRowItem'>3.00000000</td>
							<td className='withdrawsTableBodyRowItem'>mqq8sZHJkT9KyLyhDf6jSZtWuqeR9aCRTc</td>
							<td className='ordersTableBodyRowItem'><Link className='walletsTableButton' to='/withdrawDetailsCrypto'>View Details</Link></td>
						</tr>
						<tr className='withdrawsTableBodyRow'>
							<td className='withdrawsTableBodyRowItem'>014AHZ</td>
							<td className='withdrawsTableBodyRowItem'>8/10/2018, 09:11:33 AM</td>
							<td className='withdrawsTableBodyRowItem'>BTC</td>
							<td className='withdrawsTableBodyRowItem'>3.00000000</td>
							<td className='withdrawsTableBodyRowItem'>mqq8sZHJkT9KyLyhDf6jSZtWuqeR9aCRTc</td>
							<td className='ordersTableBodyRowItem'><Link className='walletsTableButton' to='/withdrawDetailsCrypto'>View Details</Link></td>
						</tr>
					</tbody>
				</table>
			</div> */}
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/withdrawsMain.tsx